// Client-safe password policy (used both client- and server-side)
export const PASSWORD_POLICY = {
  minLength: 12,
  requireUpper: true,
  requireLower: true,
  requireDigit: true,
  requireSpecial: true,
};

export function validatePassword(pw: string): string | null {
  if (pw.length < PASSWORD_POLICY.minLength) return "Le mot de passe doit contenir au moins 12 caractères.";
  if (!/[A-Z]/.test(pw)) return "Le mot de passe doit contenir au moins une majuscule.";
  if (!/[a-z]/.test(pw)) return "Le mot de passe doit contenir au moins une minuscule.";
  if (!/[0-9]/.test(pw)) return "Le mot de passe doit contenir au moins un chiffre.";
  if (!/[^A-Za-z0-9]/.test(pw)) return "Le mot de passe doit contenir au moins un caractère spécial.";
  return null;
}

export const MAX_FAILED_ATTEMPTS = 3;
